
import React from 'react';
import './style/Legend.css';

const Legend = () => {
    return (
        <div className="legend">
            <div> Air Quality Index </div>
            <div style={{ "--color": '#22b573' }}>0 - 50 | Good</div>
            <div style={{ "--color": 'yellow' }}>51 - 100 | Moderate</div>
            <div style={{ "--color": 'orange' }}> 101 - 150 | Unhealthy for Sensitive Groups</div>
            <div style={{ "--color": 'red' }}> 151 - 200 | Unhealthy </div>
            <div style={{ "--color": 'purple' }}> 201+ | Very Unhealthy	</div>

        </div>
    );
}
export default Legend;
